import type { IPersonalizedWorkspace } from 'APP/model/workspace/workspaceModel.types';
import type { PersonalizedWorkspace } from 'APP/wsApi/wsAppApi/types/workspace/workspace_model_pb';

export function mapIPersonalizedWorkspace(
  workspace: PersonalizedWorkspace
): IPersonalizedWorkspace {
  return {
    workspace: {
      name: workspace.workspace?.name || '',
      usersCount: workspace.workspace?.usersCount || 0,
      ...workspace.workspace,
    },
    role: workspace.role,
    workspaceSetting: workspace?.workspaceSetting,
    region: workspace?.region,
  };
}
